import { ChangeDetectionStrategy, Component } from '@angular/core'

@Component({
  selector: 'terms',
  imports: [],
  templateUrl: './terms.html',
  styles: [
    `
      a {
        color: #93c5fd;
        text-decoration: underline;
      }
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class Terms {}
